export default {
  data() {
    return {
 
    }
  },
  props: {
    data:{
      default:function(){
        return {}
      }
    },
  },
  watch:{

  },

  computed:{
    answer(){
      return this.data.type == 2 ? this.data.answer.split(',') : this.data.answer
    },
    defaultAnswer(){
      return this.data.type == 0 ? (this.data.defaultAnswer == 'A' ? '正确' :'错误') : this.data.defaultAnswer
    },
    options(){
      if( this.data.type == 2 || this.data.type == 1){
        let p = JSON.parse(this.data.options).map(i => ({value:i.seq , label:i.seq+'. '+i.content}))

        return p
      }else{
        return [{value:'A',label:'正确'},{value:'B',label:'错误'}]
      }
    }
  },
  created(){

  },
  methods: {
    setData(){
      
    },
  },
  render(){
    let node = null
    let { answer , options , defaultAnswer } = this
    let { type } = this.data
    if( type == 1 ){
      node = <RadioGroup value={answer} style="width:100%;">
        {
          options.map(i => <Radio style="width:100%;padding:5px 0;" label={i.value} >
            <span>{i.label}</span>
          </Radio>)
        }
      </RadioGroup>
    }
    else if(type == 2 ){
      node = <CheckboxGroup value={answer} vertical style="width:100%;">
        {
          options.map(i => <div style="width:100%;padding:5px 0;">
            <Checkbox label={i.value} >
              <span>{i.label}</span>
            </Checkbox>
          </div>)
        }
      </CheckboxGroup>
    }
    else if(type == 0){
      node = <RadioGroup value={answer}>
        {
           options.map(i => <Radio label={i.value}>{i.label}</Radio>)
        }
      </RadioGroup>
    }

    return <div>
      <div style="margin-bottom:8px;">{this.data.title}</div>
      { node }
      <div style="margin-top:8px;">正确答案：{defaultAnswer}</div>
    </div>
  }
}
